// LoadingComponent.js
import React from 'react';
import '../App.css'; // Import the CSS file

const LoadingComponent = () => {
  return (
    <div className="loading-container">
      <img
        src="/images/flip.gif" // Path to your loading GIF
        alt="Loading"
      />
    </div>
  );
}

export default LoadingComponent;
